(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patient-picture', {
            parent: 'entity',
            url: '/patient-picture',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PatientPictures'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-picture/patient-pictures.html',
                    controller: 'PatientPictureController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('patient-picture-detail', {
            parent: 'entity',
            url: '/patient-picture/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PatientPicture'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-picture/patient-picture-detail.html',
                    controller: 'PatientPictureDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PatientPicture', function($stateParams, PatientPicture) {
                    return PatientPicture.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'patient-picture',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('patient-picture-detail.edit', {
            parent: 'patient-picture-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-picture/patient-picture-dialog.html',
                    controller: 'PatientPictureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientPicture', function(PatientPicture) {
                            return PatientPicture.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-picture.new', {
            parent: 'patient-picture',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-picture/patient-picture-dialog.html',
                    controller: 'PatientPictureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                picture: null,
                                picture_content_type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patient-picture', null, { reload: 'patient-picture' });
                }, function() {
                    $state.go('patient-picture');
                });
            }]
        })
        .state('patient-picture.edit', {
            parent: 'patient-picture',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-picture/patient-picture-dialog.html',
                    controller: 'PatientPictureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientPicture', function(PatientPicture) {
                            return PatientPicture.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-picture', null, { reload: 'patient-picture' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-picture.delete', {
            parent: 'patient-picture',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-picture/patient-picture-delete-dialog.html',
                    controller: 'PatientPictureDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatientPicture', function(PatientPicture) {
                            return PatientPicture.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-picture', null, { reload: 'patient-picture' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
